import React, { useState, useEffect } from 'react'
import { usePagination } from 'app/hooks/usePagination'
import Loading from 'app/components/MatxLoading/MatxLoading'
import { DataGridPro } from '@mui/x-data-grid-pro'
import './style.css'

import { SmilesImage } from 'app/containers/SmilesDialog'
import IconButtonWithTooltip from '../IconButtonWithTooltip'
import { getFeaturesColumns } from './ColumnUtills'

const LazyLoadingSmilesDataGrid = (props) => {
  const {
    title = 'Data',
    path,
    download,
    features = {},
    featuresLabels = {},
    labels = [],
    onDownloadClick,
  } = props
  const {
    list,
    loading,
    totalElements,
    rowsPerPage,
    page,
    sort,
    filters,
    setRowsPerPage,
    setPage,
    setSortModel,
    setFilterModel,
  } = usePagination(path)
  const [columns, setColumns] = useState([])

  useEffect(() => {
    let featuresColumns = getFeaturesColumns(features, featuresLabels, labels);
    setColumns([
      {
        field: 'image',
        headerName: 'Image',
        width: 110,
        sortable: false,
        filterable: false,
        resizable: false,
        valueGetter: ({ row }) => row.smiles,
        renderCell: (params) => {
          return (
            <SmilesImage
              smiles={params.value}
              columns={featuresColumns}
              smilesData={params.row}
            />
          )
        },
      },
      { field: 'smiles', headerName: 'SMILES', width: 300 },
      ...featuresColumns,
    ])
  }, [features])

  if (loading && !list.length) {
    return (
      <div className="mt-24">
        <Loading />
      </div>
    )
  }
  const handleDownloadClick = () => {
    onDownloadClick(sort, filters)
  }
  const handlePaginationModelChange = (model) => {
    setPage(model.page)
    if (model.pageSize !== rowsPerPage) {
      setRowsPerPage(model.pageSize)
    }
  }
  return (
    <div style={{ width: '100%' }}>
      <div className="mb-2 flex items-center">
        <strong className="mr-2">{title}</strong>
        {download && (
          <IconButtonWithTooltip
            tooltip="Download"
            iconName="cloud_download"
            onClick={handleDownloadClick}
          />
        )}
      </div>
      <div style={{ width: '100%', height: '70vh' }}>
        <DataGridPro
          disableMultipleColumnsFiltering
          disableMultipleColumnsSorting
          rowHeight={100}
          loading={loading}
          disableRowSelectionOnClick
          rows={list}
          columns={columns}
          sortingMode="server"
          filterMode="server"
          density={'standard'}
          pagination
          rowCount={totalElements}
          onSortModelChange={setSortModel}
          onFilterModelChange={setFilterModel}
          onPaginationModelChange={handlePaginationModelChange}
          paginationModel={{ page, pageSize: rowsPerPage }}
          pageSizeOptions={[10, 25, 50]}
          pinnedColumns={{ left: ['image'] }}
        />
      </div>
    </div>
  );
}
export default LazyLoadingSmilesDataGrid
